module.exports = __webpack_public_path__ + "img/saudi-arabia.edee2343.png";